import { useCallback } from 'react'

import { UseHandleAmountChange } from '../interfaces'

export const useHandleAmountChange: UseHandleAmountChange = ({ setValues }) => {
  return useCallback(
    (amount: number) => {
      setValues((prevValues) => ({
        ...prevValues,
        amount: amount,
      }))
    },
    [setValues],
  )
}
